import axiosInstance from "@/config/axios";

export const getAllDocuments = async (params?: { [key: string]: string | number }) => {
    const response = await axiosInstance.get("/documents", { params });
    return response.data;
};